<template>
  <div class="displayInfo-container">
    <div class="status-content">
      <p class="status-name">当前展示中的资料</p>
      <!-- 占位 -->
      <span class="reason"></span>
    </div>

    <UserInfo :info="userData"/>

    <div class="private-con">
      <p class="tip-con"><span class="tip">对其他用户不可见信息</span></p>
      
      <p class="private-info">
        <span class="info-item">姓名: {{userData.name}}</span>
        <span class="info-item">手机号: {{userData.mobile}}</span>
      </p>
      <p class="private-info">
        <span class="info-item" v-if="userData.channelCode">从哪里了解hello部落: {{channelMap[userData.channelCode]}}</span>
        <span class="info-item"  v-if="userData.inviteCode">注册邀请码: {{userData.inviteCode}}</span>
      </p>

      <div id="display-webchat" class="bottom-private-box">
        <h3 class="title">上传微信账号二维码截图</h3>
        <img class="uploaded-code" :src="userData.wechatPicUrl" alt="" />
      </div>

      <div class="bottom-private-box">
        <h3 class="title">是否愿意在hello部落公众号上发帖晒资料</h3>
        <p class="answer">{{userData.ifPost ? '愿意' : '暂不发帖'}}</p>
      </div>
    </div>

    <router-link to="/baseInfo.html" class="upd-info">{{buttonText}}&nbsp;></router-link>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Clip from '@/components/common/clip'
import AccelerateAduit from '@/components/dialog/accelerateAduit'
import UserInfo from '@/components/common/userInfo'
import qs from 'qs'
import { UPLOAD_TYPE } from '@/config/constant'

import { isIOS, transferBytes, watermark } from '@/utils/tools'
import Storage from '@/utils/Storage'
import wxApi from '@/utils/wxAuth'

// 是否首次进入，决定需不需要在 activated 钩子函数保存草稿
let isFirstEnter = true

export default {
  name: 'DisplayInfo',
  components: {
    Clip,
    AccelerateAduit,
    UserInfo
  },
  computed: {
    ...mapState({
      userData: 'userData',
      sexMap: 'sexMap',
      educationMap: 'educationMap',
      salaryMap: 'salaryMap',
      assetsMap: 'assetsMap',
      statusMap: 'statusMap',
      constellationMap: 'constellationMap',
      channelMap: 'channelMap',
      areaData: 'areaData'
    }),
    filterAreaData () {
      let a = JSON.parse(JSON.stringify(this.areaData))
      delete a.province_list['100000']
      delete a.city_list['100100']
      return a
    },
    ...mapGetters({
      userId: 'userId',
      mId: 'mId'
    }),
    // eslint-disable-next-line vue/return-in-computed-property
    buttonText () {
      let str = '修改资料'
      switch (this.userData.basedataAuth) {
        case 3:
          str = '修改资料'
          break
        case 2:
          str = '修改的资料未通过审核'
          break
        case 1:
          str = '修改的资料已提交，待审核'
          break
      }
      return str
    },
    isEditable () {
      const base = parseInt(this.userData.basedataAuth)
      return base === 0 || base === 2 || (base === 3 && this.isEditing)
    },
    salaryArr () {
      let arr = []
      for (let i in this.salaryMap) {
        arr.push({
          value: i,
          text: this.salaryMap[i]
        })
      }
      // 去掉不限状态
      arr.shift(0)
      return arr
    },
    statusArr () {
      let arr = []
      for (let i in this.statusMap) {
        arr.push({
          value: i,
          text: this.statusMap[i]
        })
      }
      // 去掉不限状态
      arr.shift(0)
      arr.pop()
      arr.pop()
      return arr
    },
    assetsArr () {
      let arr = []
      for (let i in this.assetsMap) {
        arr.push({
          value: i,
          text: this.assetsMap[i]
        })
      }
      return arr
    }
  },
  data () {
    return {
      isEditing: false,
      clipParams: {original: 2, type: UPLOAD_TYPE.cover},
      coverParams: { type: UPLOAD_TYPE.cover },
      wxCodeParams: { type: UPLOAD_TYPE.wxCode },
      coverFile: null, // 裁切后的file对象
      wxCodeFile: null,
      isUpdateInfo: false,
      areaColumns: 2,
      isNativeForeign: false, // 籍贯地是否海外
      isForeign: false, // 所选地区是否海外
      showPicker: false,
      pickerType: 1,
      pickerData: [],
      showChatCodePop: false,
      limitLength: 500,
      isShowDialog: false,
      isShowClip: false,
      // 上传裁剪的封面图
      coverClipFile: '',
      // 裁剪原图
      tempImg: '',
      // 传给oss的裁剪原图字段
      clipOriginFile: '',
      isShowSingleDialog: false,
      isShowPreview: false,
      previewIndex: 0,
      timer: 0
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.query.upd) {
        this.isUpdateInfo = true
      } else {
        this.isUpdateInfo = false
      }
    }
  },
  methods: {
    ...mapActions({
      fetchUserData: 'fetchUserData'
    }),
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    // 计算出生肖
    calculater (year) {
      var arr1 = ['猴', '鸡', '狗', '猪', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊']
      return /^\d{4}$/.test(year) ? `属${arr1[year % 12]}` : false
    },
    // 个人资料配图
    selectedImg (e) {
      if (!e.file) {
        return this.$toast('获取图片失败')
      }
      this.tempImg = e.file
      this.isShowClip = true
    },
    handleDialogcancel () {
      this.showPicker = false
    },
    showPreview (index) {
      this.previewIndex = index
      this.isShowPreview = true
    },
    changePreview (index) {
      this.$refs['swipe'].swipeTo(index)
    },
  },
  mounted () {
    
  },
  activated () {
    let d = this.userData
    if (this.userId && d.firstBaseAuth) {
      wxApi.configShare({
        title: 'Hello单身部落',
        // desc: 'ID号-学历-工作-年龄-城市',
        desc: `${this.mId}-${this.educationMap[d.education]}-${d.ifStudent ? '在读' : d.job}-${d.age}-${parseInt(d.cityId) === 900000 ? (d.country + ' ' + d.state) : this.areaData['city_list'][d.cityId]}`,
        link: `${location.origin}/info-${this.mId}.html`,
        imgUrl: `${d.headPicUrl}`

        // imgUrl: `${location.origin}/api/member/pic?id=${d.coverPicList[0]}&type=1&targetMemberId=${d.id}`
      })
    } else {
      wxApi.configShare()
    }
  },
  deactivated () {
    wxApi.configShare()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.userData.ifMobileVerify) {
        vm.$router.replace({
          path: '/setUserData/phone.html'
        })
      }
    })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";

.displayInfo-container {
  .user-info-component {
    padding: 24px 40px 62px;
  }
  .line {
    height: 10px;
  }
  .status-content {
    position: relative;
    padding: 2px 40px;
    background: #ffdceb;
    .status-name {
      padding: 24px 28px 0;
      color: $mainColor;
      font-size: 32px;
      line-height: 44px;
      text-align: center;
    }
    .reason {
      display: block;
      color: $mainColor;
      font-size: 20px;
      line-height: 28px;
      min-height: 28px;
      text-align: center;
    }
  }
  .title {
    font-size: 32px;
    line-height: 44px;
  }
  .sub-title {
    color: #9b9b9b;
    font-size: 32px;
    line-height: 44px;
  }
  .private-con {
    padding: 0 40px 60px;
    .tip-con {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      text-align: center;
      margin-bottom: 28px;
      .tip {
        padding: 0 20px;
        color: #9b9ba1;
        font-size: 28px;
        line-height: 40px;
      }
      &:before,
      &:after {
        content: '';
        flex: 1 1 auto;
        height: 1px;
        background: #979797;
      }
    }

    .private-info {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      margin-bottom: 24px;
      color: #9B9BA1;
      font-size: 28px;
      line-height: 40px;
    }
  }
  .bottom-private-box {
    padding: 24px 40px;
    text-align: center;
    background: #F1F1F1;
    .title {
      color: #9B9BA1;
      font-size: 28px;
      line-height: 40px;
    }
    .answer {
      margin-top: 16px;
      color: rgba(#000, 0.5);
      font-size: 32px;
      line-height: 44px;
    }
    & + .bottom-private-box {
      margin-top: 24px;
    }
  }
  #display-webchat {
    .uploaded-code {
      display: block;
      margin: 10px auto 0;
      width: 160px;
    }
  }
  #accept-to-post {
    padding: 40px 40px 80px;
    text-align: center;
    .title {
      color: #383838;
      font-size: 32px;
      line-height: 1;
    }
    .tab-con {
      font-size: 0;
    }
    .tab {
      position: relative;
      display: inline-block;
      margin: 30px auto;
      width: 200px;
      border: 2px solid #ededed;
      color: rgba(#000, 0.5);
      font-size: 28px;
      line-height: 60px;
      background: #ededed;
      border-radius: 4px;
      img {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 28px;
      }
      & + .tab {
        margin-left: 60px;
      }
      &.active {
        border: 2px solid $mainColor;
        color: $mainColor;
        background: #fff;
      }
    }
    .tips {
      color: rgba(#000, 0.5);
      font-size: 28px;
      line-height: 40px;
      text-align: left;
    }
  }
  .upd-info {
    position: sticky;
    bottom: 0;
    left: 0;
    display: block;
    padding: 34px;
    width: 100%;
    color: #ff3e90;
    font-size: 32px;
    line-height: 44px;
    text-align: center;
    background: #fff;
  }
}
</style>
